export const RESET_PASSWORD_ERRORS = {
  SOCIAL_ONLY: 'socialOnly',
} as const;

export type ResetPasswordErrorType =
  (typeof RESET_PASSWORD_ERRORS)[keyof typeof RESET_PASSWORD_ERRORS];
